export default __webpack_public_path__ + "static/media/Logo_2.2fbde6c0.png";